/**
 * Coach reveal helpers
 *
 * Shared between SessionInterview and Evaluate: drives the word-by-word
 * "reveal" of an already-generated rationale string, plus the pre-score
 * text-length heuristic used to animate the strength ring before a real
 * score exists.
 */

export const streamText = (
  text: string,
  onChunk: (chunk: string) => void,
  onDone: () => void
): (() => void) => {
  const words = text.split(/(\s+)/);
  let i = 0;
  let cancelled = false;

  const tick = () => {
    if (cancelled || i >= words.length) {
      if (!cancelled) onDone();
      return;
    }
    onChunk(words[i]);
    i++;
    setTimeout(tick, 18 + Math.random() * 22);
  };

  const id = setTimeout(tick, 400);
  return () => {
    cancelled = true;
    clearTimeout(id);
  };
};

export const calcStrength = (text: string): number => {
  let score = 0;
  if (text.length > 50) score += 20;
  if (text.length > 150) score += 20;
  if (text.length > 300) score += 15;
  if (/situation|task|action|result/i.test(text)) score += 15;
  if (/I |my |we /i.test(text)) score += 10;
  if (/because|therefore|however/i.test(text)) score += 10;
  if (text.split('.').length > 3) score += 10;
  return Math.min(score, 100);
};
